
function setCookie (name, value, time) {
  var expires = ''
  if (time) {
    // var date = new Date()
    // date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + time
  }

  if (process.env.VUE_APP_NODE_TYPE === 'development') {
    document.cookie = name + '=' + value + expires + '; path=/'
  }
  if (process.env.VUE_APP_NODE_TYPE === 'devment') {
    document.cookie = name + '=' + value + expires + '; domain=.fexdrive.com; secure=true;'
  }
  if (process.env.VUE_APP_NODE_TYPE === 'production') {
    document.cookie = name + '=' + value + expires + '; domain=.fexspace.com; secure=true;'
  }
}

function getCookie (name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

function removeCookie (name) {
  document.cookie = name + '=; Max-Age=-99999999;'
}

export default { setCookie, getCookie, removeCookie }
